// extracted by mini-css-extract-plugin
module.exports = {"container":"MessageItem_container__1j0j2","time":"MessageItem_time__2Pycz","bubble":"MessageItem_bubble__Xa1iJ","left":"MessageItem_left__1DPjD","right":"MessageItem_right__3mUXX"};